import { Component, OnInit } from '@angular/core';
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from 'src/app/shared/services/common.service';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-create-template-popup',
    templateUrl: './create-template-popup.component.html',
    styleUrls: ['./create-template-popup.component.scss'],
    standalone: false
})
export class CreateTemplatePopupComponent implements OnInit {
  templates: any[] = [];
  stepOneFormGroup: FormGroup;
  backgroundColorButton: string;
  buttonColor = '';
  titleText = 'Create Template';

  get stepOneSections() {
    return this.stepOneFormGroup.get('sections') as FormArray;
  }

  constructor(
    private fb: FormBuilder,
    private localStorage: LocalStorageSettingsService,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<CreateTemplatePopupComponent>,
    private jsignalsService: JsignalService
  ) {
    // build form with default mode = 'new'
    this.stepOneFormGroup = this.fb.group({
      mode: ['new', Validators.required],   // default radio selection
      templateId: [null],                   // will be required if mode = copy
      templateName: ['', Validators.required],
      activities: [[]],
      sections: this.fb.array([])
    });
  }

  ngOnInit(): void {
    this.jsignalsService.getAllTemplates().subscribe(list => (this.templates = list));
    this.backgroundColorButton = this.localStorage.getSettings('ColorA');
  }

  onModeChange() {
    const mode = this.stepOneFormGroup.get('mode')!.value;
    if (mode === 'new') {
      this.stepOneFormGroup.get('templateId')!.reset(); // clear template selection
    }
    this.clearForm();
  }

  clearForm() {
    this.stepOneFormGroup.patchValue({
      templateName: '',
      activities: [],
      sections: []
    });
    this.stepOneSections.clear();
  }

  submit() {
    const formValue = this.stepOneFormGroup.value;
    this.dialogRef.close({
      mode: formValue.mode,
      templateId: formValue.templateId
    });
    console.log(formValue.mode, formValue.templateId);
  }

  cancel() {
    this.dialogRef.close();
  }
}
